import React from 'react';
import ImageUploadComponent from '~/components/organism/ImageUploadComponent';
import useImageUpload from '~/hooks/useImageUpload';
import Div from '~/components/atom/Div';
import AppEntryItemHeader from '~/components/page/Apps/components/AppEntryItemHeader';

export type Props = {
  initialUrl?: string | null;
  title?: string;
  description?: string;
  s3Key: string | null | undefined;
  filename: string;
  readOnly?: boolean;
  onChange: (arg?: { s3key: string; url: string }) => void;
  deletable?: boolean;
  required?: boolean;
};

const ImageInput: React.FCC<Props> = ({
  dataTestId,
  initialUrl,
  title,
  s3Key,
  filename,
  readOnly,
  onChange,
  deletable = true,
  required = false,
}) => {
  const image = useImageUpload({
    initialUrl,
    s3Key,
    onUpload: ({ s3Key, url }) => {
      if (onChange) onChange({ s3key: s3Key, url });
    },
    onClear: () => onChange && onChange(),
  });

  return (
    <Div width="100%">
      {title && (
        <AppEntryItemHeader required={required}>{title}</AppEntryItemHeader>
      )}

      <ImageUploadComponent
        onDelete={deletable ? () => image.clear() : undefined}
        uploading={image.uploading}
        imageUrl={image.s3Key != null ? image.url : null}
        onUpload={file => void image.upload({ file: file[0], filename })}
        dataTestId={dataTestId}
        disabled={readOnly}
      />
    </Div>
  );
};

export default ImageInput;
